<div class="wrap">
  <img 
    class="user-avatar" 
    *ngIf="value && !loading" 
    [src]="value"
    alt="demo-avatar"
  />
  <img 
    class="user-avatar" 
    *ngIf="!value && !loading && imgPlaceholder" 
    src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png"
    alt="demo-avatar"
  />
  <div *ngIf="loading" class="avatar-spinner-wrap">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="30"
    ></mat-progress-spinner>
  </div>
  <button 
    [disabled]="disabled" 
    class="bciti-button" 
    [ngClass]="disabled ? 'bciti-button--disabled' : 'bciti-button--lightblue-inversed upload-button'" 
    (click)="openDialog()" 
    *ngIf="allowModify"
  >
    {{ label }}
  </button>
</div>
<div *ngIf="!disableMessages" class="messages">
  <ng-content selector="app-form-error"></ng-content>
  <ng-content selector="app-form-success"></ng-content>
</div>
